export default "__VITE_ASSET__D0VLbGEf__"